import React from "react";
import { Link } from "react-router-dom";
import { Notifications } from "../../assets/svg/AllSvg";
import CustomTable from "../../commons/CustomTable";
import AllGood from "../../commons/AllGood";
import moment from "moment";

const Bulletin = ({ notificationData, loading }) => {
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-3 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades whitespace-nowrap "
        >
          No.
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Notification
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Date/Time
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Actions
        </th>
      </>
    );
  };

  const DataRows = () => {
    return (
      <>
        {(notificationData?.data || [])?.map(
          (element, index) =>
            index < 3 && (
              <tr
                className={
                  "border-b table_responsive_text bg-light_secondary hover:bg-secondary_light_shades"
                }
                key={element?.id}
              >
                <td className="px-5 py-3 truncate">{index + 1}</td>
                <td className="px-5 py-3 truncate max-w-40">
                  <div dangerouslySetInnerHTML={{ __html: element?.content }} />
                </td>
                <td className="px-5 py-3 truncate">
                  {moment(element?.created_at).format("DD/MM/YYYY | HH:MM A")}
                </td>
                <td className="px-5 py-3 truncate">
                  <Link
                    to={"/notifications"}
                    state={element}
                    className="text-theme border-b border-theme"
                  >
                    View
                  </Link>
                </td>
              </tr>
            )
        )}
      </>
    );
  };
  return (
    <>
      <p className="lg:text-lg flex items-center font-ebGaramond font-semibold mb-2">
        <Notifications
          pathClass="fill-theme"
          className="fill-theme mr-2"
          width={24}
        />{" "}
        Bulletin
      </p>
      {notificationData?.data?.length > 0 ? (
        <CustomTable
          columnHeaders={<ColumnHeaders />}
          dataRows={<DataRows />}
          data={notificationData}
          overflowVisibleLg={false}
          // loader
          loading={loading}
          showPagination={false}
        />
      ) : (
        <AllGood />
      )}
      <div className="text-right mt-3">
        <Link
          to={"/notifications"}
          className="text-theme border-b border-theme sm:text-sm text-xs font-bold uppercase text-right w-full"
        >
          View All
        </Link>
      </div>
    </>
  );
};

export default Bulletin;
